import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Smooth enter animation for page content when sidebar (or any) navigation changes route.
 * Keyed by location so same-path navigations with different state also re-animate.
 */
const PageTransition = ({ children, className = '' }) => {
  const location = useLocation();
  const transitionKey = `${location.pathname}${location.search}:${location.key}`;

  useEffect(() => {
    const prefersReducedMotion =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  }, [transitionKey]);

  return (
    <div key={transitionKey} className={`page-transition ${className}`.trim()}>
      {children}
    </div>
  );
};

export default PageTransition;
